// Data Freshness: the routes and the sidebar rows of `wealth.compliance.data-freshness` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.data-freshness',
    routes: [
        {
            frontend: 'comply',
            path: 'data-freshness',
            lazy: () => import('@/pages/comply/data-freshness/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'data-freshness',
            label: 'Data Freshness',
            href: '/comply/data-freshness',
            icon: 'Activity',
            group: 'monitoring',
            order: 440,
            wip: true,
        },
    ],
});
